import { API_HOST, getHttpGetOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/help`;

const getRetrieveFrequentlyAskedQuestionsEndpoint = () => `${getEndpoint()}/retrieve/faq`;
export const getRetrieveFrequentlyAskedQuestionsRequest = () => [
  getRetrieveFrequentlyAskedQuestionsEndpoint(),
  getHttpGetOptions(),
];

const getUpdateFrequentlyAskedQuestionsEndpoint = () => `${getEndpoint()}/update/faq`;
export const getUpdateFrequentlyAskedQuestionsRequest = (frequentlyAskedQuestions) => [
  getUpdateFrequentlyAskedQuestionsEndpoint(),
  getHttpPostOptions(frequentlyAskedQuestions),
];

const getCreateTutorialEndpoint = () => `${getEndpoint()}/add/tutorial`;
export const getCreateTutorialRequest = (tutorial) => [getCreateTutorialEndpoint(), getHttpPostOptions(tutorial)];

const getRetrieveTutorialsEndpoint = () => `${getEndpoint()}/retrieve/tutorials`;
export const getRetrieveTutorialsRequest = () => [getRetrieveTutorialsEndpoint(), getHttpGetOptions()];

const getUpdateTutorialEndpoint = () => `${getEndpoint()}/update/tutorial`;
export const getUpdateTutorialRequest = (tutorial) => [getUpdateTutorialEndpoint(), getHttpPostOptions(tutorial)];

const getDeleteTutorialEndpoint = (externalReference) => `${getEndpoint()}/delete/tutorial/${externalReference}`;
export const getDeleteTutorialRequest = (externalReference) => [
  getDeleteTutorialEndpoint(externalReference),
  getHttpGetOptions(),
];
